import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { addInvoiceFailure, addInvoiceStart, addInvoiceSuccess, deleteInvoiceFailure, deleteInvoiceStart, deleteInvoiceSuccess, getDetailInvoiceEnvoisRamassageDepotFailure, getDetailInvoiceEnvoisRamassageDepotStart, getDetailInvoiceEnvoisRamassageDepotSuccess, getEnvoisRamassageDepotFailure, getEnvoisRamassageDepotStart, getEnvoisRamassageDepotSuccess, getInvoicesFailure, getInvoicesStart, getInvoicesSuccess } from './InvoiceActions';

const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getInvoices = async (dispatch, pageSize, page, idInvoice, entrepriseId, dateApplyInvoice, dateCreationInvoice) => {
    let invoiceFilter = { idInvoice, entrepriseId, dateApplyInvoice, dateCreationInvoice };
    dispatch(getInvoicesStart());
    try {
        const res = await axiosInstance.post(`/admin/invoices?pageSize=${pageSize}&page=${page}`, invoiceFilter, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getInvoicesSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(getInvoicesFailure(err.response.data.message))
        } else {
            dispatch(getInvoicesFailure("Unkown Error"))
        }
    }
}

export const loadInvoice = async (dispatch, page, pageSize, entrepriseId, dateApply) => {
    dispatch(getEnvoisRamassageDepotStart());
    try {
        const res = await axiosInstance.post(`/admin/invoices/loading?pageSize=${pageSize}&page=${page}`, { entrepriseId, dateApplyInvoice: dateApply }, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getEnvoisRamassageDepotSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(getEnvoisRamassageDepotFailure(err.response.data.message))
        } else {
            dispatch(getEnvoisRamassageDepotFailure("Unkown Error"))
        }
    }
}

export const detailInvoice = async (dispatch, pageSize, page, invoiceId,) => {
    dispatch(getDetailInvoiceEnvoisRamassageDepotStart());
    try {
        const res = await axiosInstance.post(`/admin/invoices/detail?pageSize=${pageSize}&page=${page}`, { invoiceId }, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getDetailInvoiceEnvoisRamassageDepotSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(getDetailInvoiceEnvoisRamassageDepotFailure(err.response.data.message))
        } else {
            dispatch(getDetailInvoiceEnvoisRamassageDepotFailure("Unkown Error"))
        }
    }
}

export const createInvoice = async (dispatch, total, totalEnvois, sumMontant, totalRamassage, totalDepot, entrepriseId, dateApplyInvoice, allEnvois, historiesRamassage, historiesDepot, withTVA) => {
    dispatch(addInvoiceStart());
    var listRamassage = historiesRamassage.map(item => item.id);
    var listDepot = historiesDepot.map(item => item.id);
    var listHistories = [...listRamassage, ...listDepot];
    var listEnvois = allEnvois.map(item => item.id)

    try {
        const res = await axiosInstance.post(`/admin/invoices/add`, { total, totalEnvois, sumMontant, totalRamassage, totalDepot, entrepriseId, dateApplyInvoice, listHistories, listEnvois, withTVA }, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addInvoiceSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(addInvoiceFailure(err.response.data.message))
        } else {
            dispatch(addInvoiceFailure("Unkown Error"))
        }
    }
}

export const deleteInvoice = async (dispatch, invoiceId)=>{
    dispatch(deleteInvoiceStart());
    try {
        const res = await axiosInstance.post(`/admin/invoices/delete`, { invoiceId }, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(deleteInvoiceSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(deleteInvoiceFailure(err.response.data.message))
        } else {
            dispatch(deleteInvoiceFailure("Unkown Error"))
        }
    }
}

